/**
 * Modal Helper Functions
 *
 * Provides reusable functions for working with Bootstrap modals.
 * Compatible with Bootstrap 4.6.
 */

import { logError, logWarning, safeDOM } from '../../core/error-handler.js';

/**
 * Load detail content into modal and show it
 * @param {string} url - URL to load content from
 * @param {object} data - Data to send with request (e.g., { id: 123 })
 * @param {string} modalId - ID of modal element
 * @param {string} title - Modal title
 */
export function modalDetailRequest(url, data, modalId, title) {
    const $modal = safeDOM(() => $(`#${modalId}`), { modalId });
    if (!$modal || $modal.length === 0) {
        logWarning('Modal element not found', { modalId });
        return;
    }

    const $modalBody = $(`#${modalId}Body`);
    const $modalTitle = $(`#${modalId}Title`);

    $modalTitle.text(title);
    $modalBody.html(
        '<div class="text-center py-5"><i class="fas fa-spinner fa-spin fa-2x"></i> Načítám...</div>'
    );

    $modal.modal('show');

    $.ajax({
        url: url,
        type: 'GET',
        data: data,
        success: function (result) {
            $modalBody.html(result);
        },
        error: function (xhr) {
            const errorMsg = `<div class="alert alert-danger">Chyba při načítání obsahu: ${xhr.statusText}</div>`;
            $modalBody.html(errorMsg);
            logError(new Error('Failed to load modal content'), {
                url,
                modalId,
                status: xhr.status
            });
        }
    });
}

// Export to window for global access (backwards compatibility with non-ES6 code)
window.ModalDetailRequest = modalDetailRequest;
